import { render, staticRenderFns } from "./IClear.vue?vue&type=template&id=22fc5ab5&scoped=true&"
import script from "./IClear.vue?vue&type=script&lang=js&"
export * from "./IClear.vue?vue&type=script&lang=js&"
import style0 from "./IClear.vue?vue&type=style&index=0&id=22fc5ab5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc5ab5",
  null
  
)

export default component.exports